export const getLeftMenuData = [
  {
    key: "dashboard.title",
    url: "/dashboard",
    icon: "icmn icmn-home",
  },
  {
    key: "admin.user.title",
    url: "/user",
    icon: "icmn icmn-users",
  },
  {
    key: "admin.transaction.title",
    url: "/admin_transaction",
    icon: "icmn icmn-credit-card",
  },
  {
    key: "room.title",
    url: "/room",
    icon: "icmn icmn-heart",
  },
  {
    key: "restaurant.title",
    url: "/restaurant",
    icon: "icmn icmn-office",
  },
  {
    key: "post.title",
    url: "/post",
    icon: "icmn icmn-file-text",
  },
  {
    key: "admin.statistics.title",
    url: "/statistics",
    icon: "icmn icmn-stats-dots",
  },
  {
    key: "setting.title",
    url: "/setting",
    icon: "icmn icmn-cog",
  },
  {
    key: "rate.title",
    url: "/rate",
    icon: "icmn icmn-star-full",
  },
  {
    key: "debug.title",
    url: "/debug",
    icon: "icmn icmn-wrench",
  },
];
